<nz-space class="mobile-report-control">
  <app-agent-select [showAddNewButton]="false" [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="code" [activeOnly]="false">
  </app-agent-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-agent-select  [showAddNewButton]="false" [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="code" [activeOnly]="false">
  </app-agent-select>
</nz-space>
